import {initenv} from './wxsys/lib/base/initenv';
 wx.App = {baseUrl: '', resPath: ''};
initenv();
new wx.ShareData({"name":"登录用户","className":"/main/dengluyh","type":"common-data"});
App({



})
import '../core/framework/app';
import AppConfig from './app.json';
getApp().setAppConfig(AppConfig);



// WEBPACK FOOTER //
// ./pages/app.js